'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var NumericalSelectionReporter = require('../NumericalSelectionReporter/NumericalSelectionReporter.js');
var styledComponents = require('./styled-components.js');

var NumberSelectedWithText = function (props) {
    var title = props.title, start = props.start, end = props.end, selected = props.selected;
    return (React__default.createElement("div", null,
        typeof title === 'string' && title.length > 0 && (React__default.createElement(styledComponents.StyledInputLabel, { "data-testid": 'number-selected-title' }, title)),
        typeof title !== 'string' && title,
        React__default.createElement(NumericalSelectionReporter, { start: start, end: end, selected: selected })));
};

module.exports = NumberSelectedWithText;
